import { Injectable } from '@angular/core';
import { Constants } from 'app/modules/common/constants/constants';
import { AbsenteeismChartTypes } from 'app/modules/common/enums/absenteeism-chart-types';
import { ChartDataset } from 'chart.js';
import { MonthlyAbsenteeism } from '../entities/coordinator-absenteeism';

@Injectable({
  providedIn: 'root'
})
export class ChartService {

  public absenteeismData: ChartDataset[];
  public monthLabels: string[];

  private MENSUAL = 'Abs. Mensual';
  private ACUMULADO = 'Abs. Acumulado';
  private INTERANUAL = 'Abs. Interanual';

  constructor() { }

  public setAbsenteeismData(absenteeismData: MonthlyAbsenteeism[]): void {
    this.setChartLabels(absenteeismData[0].mes);

    const mensual: ChartDataset = { data: [], label: this.MENSUAL, 
      borderColor: '#339C9C', backgroundColor: '#339C9C', fill: false, pointBackgroundColor: '#339C9C', pointHoverBorderColor: '#339C9C' };
    const acumulado: ChartDataset = { data: [], label: this.ACUMULADO, 
      borderColor: '#FFA154', backgroundColor: '#FFA154', fill: false, pointBackgroundColor: '#FFA154', pointHoverBorderColor: '#FFA154' };
    const interanual: ChartDataset = { data: [], label: this.INTERANUAL, 
      borderColor: '#4564ad', backgroundColor: '#4564ad', fill: false, pointBackgroundColor: '#4564ad', pointHoverBorderColor: '#4564ad' };

    absenteeismData.forEach((value, index) => {
      let pushedValue = value.absentismo ? Number(value.absentismo.toFixed(2)) : 0;
      mensual.data.push(pushedValue);

      pushedValue = value.absAcumulado ? Number(value.absAcumulado.toFixed(2)) : 0;
      acumulado.data.push(pushedValue);

      pushedValue = value.absInteranual ? Number(value.absInteranual.toFixed(2)) : 0;
      interanual.data.push(pushedValue);
    });

    this.absenteeismData = new Array<ChartDataset>();
    this.absenteeismData.push(mensual);
    this.absenteeismData.push(acumulado);
    this.absenteeismData.push(interanual);
  }

  public getAbsenteeismData(selectedChartType: AbsenteeismChartTypes): ChartDataset[] {
    
    switch (selectedChartType) {
      case AbsenteeismChartTypes.All:
        return this.absenteeismData;

      case AbsenteeismChartTypes.Absentismo:
        return this.absenteeismData.filter(e => e.label === this.MENSUAL);

      case AbsenteeismChartTypes.Acumulado:
        return this.absenteeismData.filter(e => e.label === this.ACUMULADO);

      case AbsenteeismChartTypes.Interanual:
        return this.absenteeismData.filter(e => e.label === this.INTERANUAL);

      default:
        return new Array<ChartDataset>();
    }

  }

  private setChartLabels(startMonth: number): void {
    const startLabels = new Array<string>();
    const endLabels = new Array<string>();

    Constants.monthsShort.forEach((value, index) => {
      if((index + 1) >= (startMonth)) {
        startLabels.push(value);
      } else {
        endLabels.push(value);
      }
    });

    this.monthLabels = startLabels.concat(endLabels);
  }
}
